import { ClientId } from "@fartherfinance/frontend/api/Types";

import { GoalOwnerFieldType } from "../../Goals/Forms/types";

export const getOwnerOption = (
  clientId: ClientId,
  ownerOptions: GoalOwnerFieldType[]
): GoalOwnerFieldType => {
  const ownerOption = ownerOptions.find((el) => el.value === clientId);

  if (ownerOption === undefined) {
    throw new Error(`Owner with clientId ${clientId} not found`);
  }

  return ownerOption;
};
